import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className='footer'>
      <p>
        © Sasha Chaddah MD 2024
      </p>
      <p>
      <a href="https://redefinemd.com/">Redefine MD</a> 
      </p>
      <p>
        Webmaster: <a href="https://juliendarling-funk.com/">Julien Darling-Funk Design</a> 
      </p>
    </div>
  )
}

export default Footer
